import { render, staticRenderFns } from "./mini-cart.vue?vue&type=template&id=62b187d7&lang=pug"
import script from "./mini-cart.vue?vue&type=script&lang=js"
export * from "./mini-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports